import { useContext, FC, useState } from 'react'

import { CustomFormQuestion, CustomFormQuestionError, CustomFormViewerProps } from 'components/tools/CustomForm/types'
import CustomFormViewerContext, { CustomFormViewerManagerContextType } from './Context'

export type Props = CustomFormViewerProps & {
  children?: JSX.Element
}

const CustomFormViewerProvider: FC<Props> = ({ children, ...props }) => {
  const [questionErrors, setQuestionErrors] = useState<CustomFormQuestionError[]>([])

  const thisQuestionHasError = (questionSlug?: string) => {
    const wrongQuestion = questionErrors.filter((questionError) => {
      return questionError.slug === questionSlug
    })
    if (wrongQuestion.length === 0) return { hasError: false, question: {} }
    return { hasError: wrongQuestion.length > 0, question: wrongQuestion[0] }
  }

  const removeErrorFromQuestion = (questionSlug?: string) => {
    const updateQuestionErrors = questionErrors.filter((questionError) => {
      return questionError.slug !== questionSlug
    })
    setQuestionErrors(updateQuestionErrors)
  }

  const setErrorOnQuestion = (question: CustomFormQuestion, errorMessage: string) => {
    const questionAlreadyWrong = questionErrors.filter((questionErrorItem) => {
      return questionErrorItem.slug === question.slug
    })
    if (questionAlreadyWrong.length === 0) {
      setQuestionErrors([...questionErrors, { ...question, error_message: errorMessage }])
    } else {
      const updateQuestionWithError = questionErrors.map((questionErrorItem) => {
        if (questionErrorItem.slug === question.slug) return { ...question, error_message: errorMessage }
        return questionErrorItem
      })
      setQuestionErrors(updateQuestionWithError)
    }
  }

  return (
    <CustomFormViewerContext.Provider
      value={{
        thisQuestionHasError,
        removeErrorFromQuestion,
        setErrorOnQuestion,
        questionErrors,
        setQuestionErrors,
        ...props,
      }}
    >
      {children}
    </CustomFormViewerContext.Provider>
  )
}

export default CustomFormViewerProvider

export const useCustomFormViewer = () => useContext<CustomFormViewerManagerContextType>(CustomFormViewerContext)
